import styled from 'styled-components';

export const LayoutPickerContainer = styled.div.attrs({
  'data-test': 'LayoutPicker',
})`
  align-self: stretch;
  display: flex;
  justify-content: center;
`;

export const StyledButton = styled.button`
  outline: none;
  cursor: pointer;
  padding: 0 8px;
  position: relative;
  fill: ${p => p.theme.colors.base400};

  svg g,
  svg path {
    fill: ${p => p.theme.colors.base400};
  }

  &:hover {
    svg g,
    svg path {
      fill: ${p => p.theme.colors.maybeBlue500};
    }
  }
`;
